/**
 * Cấu hình → "Tính năng của tiệm" (chỉ chủ tiệm, ADR-074, KH-GĐ2 4.1.7).
 * Mỗi dòng: một công tắc + một câu giải thích. Lưu NGAY khi gạt, như cách chủ tiệm bật Wi-Fi.
 * Máy chủ từ chối tắt thứ đang dùng dở (nhiều chi nhánh, còn người vai Quản lý / Lễ tân) — câu lỗi hiện ở trên.
 */
import { TINH_NANG_DA_CO, type TinhNang } from '@sapa/shared'
import { useState } from 'react'
import { caiDatApi } from './api.ts'
import { datCaiDat, useCaiDatTiem } from './cai-dat-tiem.ts'
import { MO_TA_TINH_NANG, TN } from './text/tinh-nang.ts'
import { Xuong } from './ui.tsx'

export function TheTinhNang({
  onLoi,
  onXong,
}: {
  onLoi: (e: unknown) => void
  onXong: (cau: string) => void
}) {
  const c = useCaiDatTiem()
  const [dang, setDang] = useState<TinhNang | null>(null)

  async function doi(t: TinhNang, bat: boolean, ten: string) {
    setDang(t)
    try {
      datCaiDat(await caiDatApi.luu({ tinhNang: { [t]: bat } }))
      onXong(bat ? TN.daBat(ten) : TN.daTat(ten))
    } catch (e) {
      onLoi(e)
    } finally {
      setDang(null)
    }
  }

  if (c === null) return <Xuong cao={320} />
  return (
    <section className="the the-dem the-khoi">
      <h2>{TN.tieuDe}</h2>
      <p className="chu-phu">{TN.giaiThich}</p>
      <div className="ds-tinh-nang">
        {TINH_NANG_DA_CO.map((t) => {
          const mt = MO_TA_TINH_NANG[t]
          if (mt === undefined) return null
          return (
            <label key={t} className="cong-tac-dong tinh-nang-dong">
              <span className="chu">
                <b>{mt.ten}</b>
                <span>{mt.cau}</span>
              </span>
              <input
                type="checkbox"
                checked={c.tinhNang[t]}
                disabled={dang !== null}
                onChange={(e) => void doi(t, e.target.checked, mt.ten)}
              />
            </label>
          )
        })}
      </div>
      <p className="chu-phu">{TN.luonCo}</p>
    </section>
  )
}
